// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"viewTab_wrapper__3-8rK","tab":"viewTab_tab__1UdQX","activeTab":"viewTab_activeTab__1ZHME"};